module.exports = __webpack_public_path__ + "static/media/pos_data_recovery.bd151334.jpg";